/**
 * DTO for the response containing frequent shift times.
 */
export interface FrequentShiftTimesDto {
  timePairs: FrequentShiftTimePairDto[]; // List of frequent time pairs ordered by weighted score (descending)
}

export interface FrequentShiftTimePairDto {
  startTime: string; // Start time of the shift (format: HH:mm:ss), e.g., "07:00:00"
  endTime: string; // End time of the shift (format: HH:mm:ss), e.g., "15:00:00"
  weightedScore: number; // Weighted frequency score (recent shifts count 1.5x more), e.g., 12.5
  totalOccurrences: number; // Total number of shifts with this time pair, e.g., 10
}
